import type { FrontdeskMessages } from "./messages.en";

export const frontdeskEs: Partial<Record<keyof FrontdeskMessages, string>> = {
  "frontdesk.nav.desk": "Recepción",
  "frontdesk.nav.desks": "Puestos",

  "frontdesk.title": "Recepción",
  "frontdesk.subtitle": "Llegadas y estado de los sistemas, para el puesto donde trabaja.",
  "frontdesk.picker": "Puesto",
  "frontdesk.none.title": "No hay ningún puesto que mostrar",
  "frontdesk.none.manager": "Todavía no hay ningún puesto. Configure uno ahora con llegadas, reloj y estado, o cree el suyo en Puestos.",
  "frontdesk.none.setUp": "Configurar una recepción",
  "frontdesk.none.defaultName": "Recepción",
  "frontdesk.none.staff": "Todavía no está asignado a ningún puesto. Pida a un gerente que lo agregue a uno.",
  "frontdesk.desk.noWidgets": "Este puesto aún no tiene paneles. Un gerente puede agregarlos con Editar diseño del puesto.",
  "frontdesk.desk.allHidden": "Ha ocultado todos los paneles de este puesto. Use Personalizar para volver a mostrarlos.",

  "frontdesk.widget.arrivals": "Llegadas",
  "frontdesk.widget.system_status": "Estado de los sistemas",
  "frontdesk.widget.clock": "Reloj",
  "frontdesk.widget.notes": "Notas del puesto",
  "frontdesk.widget.call_log": "Registro de llamadas",
  "frontdesk.widget.lightning": "Rayos",
  "frontdesk.widget.camera": "Cámara",
  "frontdesk.placeholder": "Este panel estará disponible en una próxima actualización.",

  "frontdesk.callLog.needAccess": "Necesita permiso para leer el registro de llamadas.",
  "frontdesk.callLog.none": "Todavía no hay llamadas.",
  "frontdesk.callLog.unknown": "Llamante desconocido",
  "frontdesk.callLog.openLog": "Abrir el registro de llamadas",
  "frontdesk.callLog.direction.inbound": "Entrante",
  "frontdesk.callLog.direction.outbound": "Saliente",
  "frontdesk.callLog.direction.internal": "Interna",

  "frontdesk.arrivals.dayControls": "Elegir el día",
  "frontdesk.arrivals.previousDay": "Día anterior",
  "frontdesk.arrivals.nextDay": "Día siguiente",
  "frontdesk.arrivals.today": "Hoy",
  "frontdesk.arrivals.backToToday": "Volver a hoy",
  "frontdesk.arrivals.none": "No se espera a nadie este día.",
  "frontdesk.arrivals.noTime": "A cualquier hora",
  "frontdesk.arrivals.host": "Anfitrión: {name}",
  "frontdesk.arrivals.kind.guest": "Invitado",
  "frontdesk.arrivals.kind.lodging": "Estadía",
  "frontdesk.arrivals.kind.event": "Evento",
  "frontdesk.arrivals.kind.dining": "Comedor",
  "frontdesk.arrivals.status.expected": "Esperado",
  "frontdesk.arrivals.status.arrived": "Llegó",
  "frontdesk.arrivals.status.departed": "Se fue",
  "frontdesk.arrivals.status.no_show": "No se presentó",

  "frontdesk.status.label.database": "Base de datos",
  "frontdesk.status.label.installation": "Instalación",
  "frontdesk.status.label.licence": "Licencia",
  "frontdesk.status.label.email": "Correo electrónico",
  "frontdesk.status.label.lightning": "Rayos",
  "frontdesk.status.label.pbx": "Sistema telefónico",
  "frontdesk.status.label.cameras": "Cámaras",
  "frontdesk.status.state.ok": "Bien",
  "frontdesk.status.state.warning": "Requiere atención",
  "frontdesk.status.state.error": "Problema",
  "frontdesk.status.state.not_configured": "Sin configurar",
  "frontdesk.status.checked": "Revisado a las {time}",

  "frontdesk.clock.zone": "Hora del club ({zone})",
  "frontdesk.notes.empty": "Este puesto aún no tiene notas.",

  "frontdesk.customise.open": "Personalizar",
  "frontdesk.customise.title": "Personalizar {desk}",
  "frontdesk.customise.description": "Elija qué paneles ve en este puesto y de qué tamaño. Solo afecta a su propia pantalla.",
  "frontdesk.customise.reset": "Volver al diseño del puesto",
  "frontdesk.customise.empty": "Este puesto no tiene paneles que personalizar.",
  "frontdesk.customise.show": "Mostrar {widget}",
  "frontdesk.customise.width": "Ancho (columnas)",
  "frontdesk.customise.height": "Alto (filas)",

  "frontdesk.layout.edit": "Editar diseño del puesto",
  "frontdesk.layout.title": "Diseño de {desk}",
  "frontdesk.layout.subtitle": "La pantalla tiene {columns} columnas de ancho. Todos en este puesto ven este diseño y pueden ocultar o cambiar el tamaño de los paneles en su propia pantalla.",
  "frontdesk.layout.back": "Volver a Recepción",
  "frontdesk.layout.save": "Guardar diseño",
  "frontdesk.layout.saved": "Diseño guardado.",
  "frontdesk.layout.addGroup": "Agregar un panel",
  "frontdesk.layout.type": "Panel",
  "frontdesk.layout.add": "Agregar panel",
  "frontdesk.layout.noRoom": "No hay espacio para otro panel de ese tamaño. Quite uno o reduzca uno primero.",
  "frontdesk.layout.empty": "Este diseño está vacío. Agregue un panel para empezar.",
  "frontdesk.layout.list": "Paneles de este diseño",
  "frontdesk.layout.remove": "Quitar {widget}",
  "frontdesk.layout.column": "Columna",
  "frontdesk.layout.row": "Fila",
  "frontdesk.layout.width": "Ancho (columnas)",
  "frontdesk.layout.height": "Alto (filas)",
  "frontdesk.layout.notesText": "Texto de {widget}",
  "frontdesk.problem.tooMany": "Un diseño puede tener como máximo {max} paneles.",
  "frontdesk.problem.tooWide": "El panel \"{id}\" pasa de la columna {columns}. Muévalo a la izquierda o hágalo más angosto.",
  "frontdesk.problem.tooLow": "El panel \"{id}\" pasa de la fila {rows}. Muévalo hacia arriba o hágalo más bajo.",
  "frontdesk.problem.overlap": "Los paneles \"{a}\" y \"{b}\" se superponen. Mueva uno de ellos.",

  "frontdesk.desks.title": "Puestos",
  "frontdesk.desks.subtitle": "Las pantallas desde las que trabaja su personal, quién trabaja en cada una y cómo está organizada.",
  "frontdesk.desks.new": "Nuevo puesto",
  "frontdesk.desks.rename": "Cambiar {desk}",
  "frontdesk.desks.name": "Nombre",
  "frontdesk.desks.description": "Descripción",
  "frontdesk.desks.nameRequired": "Póngale un nombre al puesto.",
  "frontdesk.desks.empty": "Todavía no hay puestos",
  "frontdesk.desks.emptyBody": "Cree un puesto, como Recepción o Tienda de golf, organice su pantalla y elija quién trabaja allí.",
  "frontdesk.desks.staff": "Personal",
  "frontdesk.desks.staffCount_one": "{count} persona",
  "frontdesk.desks.staffCount_other": "{count} personas",
  "frontdesk.desks.state": "Estado",
  "frontdesk.desks.actions": "Acciones",
  "frontdesk.desks.active": "Activo",
  "frontdesk.desks.inactive": "Inactivo",
  "frontdesk.desks.renameButton": "Cambiar",
  "frontdesk.desks.renameOf": "Cambiar {desk}",
  "frontdesk.desks.staffButton": "Personal",
  "frontdesk.desks.staffOf": "Elegir el personal de {desk}",
  "frontdesk.desks.layoutButton": "Diseño",
  "frontdesk.desks.layoutOf": "Editar el diseño de {desk}",
  "frontdesk.desks.deactivate": "Desactivar {desk}",
  "frontdesk.desks.activate": "Activar {desk}",
  "frontdesk.desks.staffTitle": "Personal de {desk}",
  "frontdesk.desks.staffHelp": "Marque a las personas que trabajan en este puesto. Verán el puesto en su pantalla de Recepción.",
  "frontdesk.desks.staffList": "Usuarios del club",

  "apiError.desk_name_taken": "Ya hay otro puesto con este nombre.",
  "apiError.desk_not_found": "Ese puesto ya no existe. Recargue para ver los puestos actuales.",
  "apiError.club_user_not_found": "Esa persona ya no es usuaria de este club.",
  "apiError.not_at_desk": "Esa persona no está asignada a este puesto.",
  "apiError.prefs_do_not_fit": "Esas opciones no caben en la pantalla. Oculte un panel que estorbe o reduzca uno.",
};
